export default $axios => ({
  getSettingByCompanyId() {
    return $axios.get('/v1/get-setting');
  },
});
